/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CancelAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function CancelAction({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/CancelAction",
  isSubmitting,
  onClose
  
}) {
let newPatientIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'new_patient',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="secondary"
 data="new_patient"
 disabled={newPatientIsSubmittingData}
 onClick={onClose}
 text="Cancel"
/>
{children}
</React.Fragment>)
}